import React, { Component } from 'react';
import { connect } from 'react-redux';
import InsightsSimilarHomes from './InsightsSimilarHomes';

import { withLastLocation } from "react-router-last-location";
import { trackEvent } from '../../../../helpers/analyticsHelper';

import { fetchSHCGraphData, fetchSHComparisonInfoData } from '../../../../dataFetchers/insightsPageDataFetcher';
import { getDataNotAvailableText, fetchBillingCycleDateBoundaries, checkIfDataEmpty, setSHChartDataForBC } from '../../../../helpers/UsageDashboardHelper';
import { saveSHCChartPayload, saveApplianceNavbarList, setSHCdata, apiError, dataNotAvailable, saveBillingCyclePeriod, setArrowDisabled, updateHighChartsObject, setSimilarHomesChartsData, saveBCData, changeYearOffset, changeSelectedSHCAppliance } from '../../../../actions/insightsSimilarHomesActions';
import { displayCost, displayUsage, getBECompatibleFuelType } from '../../../../helpers/helper';
import { USAGE_SHC_EVENTS, FONT_WEIGHT, PAGE_EVENT_NAMES, FUEL_TYPE, INSIGHTS_PAGES, ARROWS, USAGE_TYPE, MAX_BC_TO_SHOW } from '../../../../constants/common';
import { COLOR_PALETTE } from '../../../../constants/colors';
import { Configuration } from '../../../../configs/Configuration';
import insightsSimilarHomeComparisonApiBody from '../../../../mockApis/insightsSimilarHomeComparison';
import { setQueryParams} from  "../../../../actions/queryParamsAction";
import { getApplianceName } from '../../../../helpers/itemizationDataHelper';

const seriesMapping = {
    'average': 'AVERAGE',
    'you': 'YOU',
    'efficient': 'EFFICIENT'};

class InsightsSimilarHomesContainer extends Component {
    configColors = Configuration.getColors().colors;
    
    componentDidMount() {
        //call function to fetch data
        if (this.props.insightsSHData.insightsSHChartsData.length === 0) {
            this.fetchSHCGraphData();
        } else {
            this.setGraphOptions();
        }
        if (this.props.insightsSHData.shcData.length === 0) {
            this.fetchSHCInfoData();
        }

        //call analytics function to save viewed event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            viewed: true,
            dashboardView: FUEL_TYPE.ELECTRIC,
            shown: INSIGHTS_PAGES.SIMILAR_HOMES
        }, this.props)
    }

    componentDidUpdate(prevProps, prevState) {
        const { insightsSHData } = this.props;
        if (insightsSHData.usageChartEvent === USAGE_SHC_EVENTS.CHANGE_YEAR_OFFSET) {
            this.props.setArrowDisabled({
                insightsDataLeftArrowDisabled: (insightsSHData.bcIndexOffset >= insightsSHData.bcDurations.length - MAX_BC_TO_SHOW),
                insightsDataRightArrowDisabled: (insightsSHData.bcIndexOffset === 0),
                usageChartEvent: USAGE_SHC_EVENTS.SET_ARROW_DISABLED
            });
            this.setGraphOptions();
        }

        if (insightsSHData.usageChartEvent === USAGE_SHC_EVENTS.SET_HIGHCHARTS_DATA) {
            this.checkIfDataEmpty();
            this.updateHighChartsObject();
            this.setBillingCyclesInfo();
        }

        if (insightsSHData.usageChartEvent === USAGE_SHC_EVENTS.SAVE_APPLIANCE_NAVBAR_LIST) {
            insightsSHData.appliancesSHCList && insightsSHData.appliancesSHCList.length > 0 && this.onSHCRecoChange(insightsSHData.appliancesSHCList[0].id);
        }

        if (insightsSHData.shcGraphData && insightsSHData.usageChartEvent === USAGE_SHC_EVENTS.SAVE_CHART_API_PAYLOAD ) {
            this.setHighchartsData(insightsSHData.shcGraphData);
        }

        if (insightsSHData.usageChartEvent === USAGE_SHC_EVENTS.SIMILAR_HOMES_API_ERROR) {
            this.setHighchartsData(insightsSimilarHomeComparisonApiBody);
        }
    }

    updateHighChartsObject() {
        let self = this;
        const tooltipBgColor = `rgb(${this.configColors['--color_54']})`, textColor = `rgb(${this.configColors['--color_2']})`, gridLineColor = `rgb(${this.configColors['--color_8']})`;
        let totalPoints = this.props.insightsSHData.dataXAxis.length;
        let bcIndexOffset = this.props.insightsSHData.bcIndexOffset;
        let categories = this.props.insightsSHData.dataXAxis;
        if (totalPoints >= MAX_BC_TO_SHOW) {
            categories = this.props.insightsSHData.dataXAxis.slice(totalPoints - (MAX_BC_TO_SHOW + bcIndexOffset), totalPoints - bcIndexOffset);
        }

        this.props.updateHighChartsObject({
            options: {
                chart: {
                    style: {
                        marginBottom: 30
                    }
                },
                legend: {
                    itemStyle: {
                        color: textColor,
                        fontWeight: FONT_WEIGHT.medium,
                        fontSize: '14px'
                    },
                    align: 'left',
                    symbolPadding: 0,
                    symbolHeight: 0.1,
                    symbolWidth: 0.1,
                    symbolRadius: 0.1,
                    x: 60,
                    useHTML: true,
                    labelFormatter: function () {
                        let legendText = self.props.translationsData.data[`SIMILAR_HOMES.CHART.LABELS.${seriesMapping[this.name]}`];
                        return `<div class="legend-wrapper"><span class="symbol ${this.name}"></span><span>${legendText}</span></div>`;
                    },
                    navigation: {
                        enabled: false
                    }
                },
                xAxis: [{
                    startOnTick: true,
                    arrowOnEnd: true,
                    categories: categories,
                    labels: {
                        style: {
                            color: textColor,
                            fontSize: '12px',
                            paddingTop: '20px'
                        },
                        padding: 0,
                        y: 25
                    },
                    lineColor: textColor,
                    gridLineColor: gridLineColor
                }],
                yAxis: {
                    min: 0,
                    title: {
                        text: '',
                    },
                    labels: {
                        formatter: function() {
                            return self.props.configs.data.defaultCostConsumptionModeSHC === USAGE_TYPE.COST ? displayCost({showCurrency: true, cost: this.value}) : displayUsage({showUsageUnit: true, usage: this.value, fuelType: self.props.configs.data.fuelType.toLowerCase() })
                        },
                        style: {
                            color: textColor,
                            fontSize: '12px',
                            marginBottom: '10px'
                        }
                    }
                },
                tooltip: {
                    useHTML: true,
                    backgroundColor: tooltipBgColor,
                    shared: true,
                    formatter: function() {
                       return self.setTooltip(this.points);
                    },
                    crosshair: {
                        enabled: false
                    },
                    style: {
                        color: textColor
                    },
                    padding: 20,
                    borderRadius: 8,
                    borderWidth: 0
                },
                plotOptions: {
                    series: {
                        marker: {
                            symbol: 'round'
                        },
                        states: {
                            hover: {
                                halo: {
                                    size: 0
                                }
                            }
                        },
                        animation: false
                    },
                    line: {
                        lineWidth: 3
                    }
                },
                series: self.props.insightsSHData.insightsSHChartsData
            },
            isSHChartLoading: false,
            usageChartEvent: USAGE_SHC_EVENTS.UPDATE_HIGHCHARTS_OBJECT
        });
    } //updatechartobject

    setTooltip(chartPoints) {
        let allBCs = this.props.insightsSHData.bcDurations;
        let titleLabels = allBCs;
        if (allBCs.length >= MAX_BC_TO_SHOW) {
            titleLabels = allBCs.slice(allBCs.length - MAX_BC_TO_SHOW - this.props.insightsSHData.bcIndexOffset, allBCs.length - this.props.insightsSHData.bcIndexOffset);
        }

        let title = titleLabels[chartPoints[0].point.index];
        let translations = this.props.translationsData.data;

        return chartPoints.reduce((s, point) => {
            let tooltipText = translations[`SIMILAR_HOMES.CHART.LABELS.${seriesMapping[point.series.name]}`];
            return `${s} <span class="tooltip-item-container">
                            <span style="background-color: ${point.color}" class="tooltip-symbol"></span>
                            <span class="tooltip-item-text ${point.series.name}"><span class="amount-text"> ${this.props.configs.data.defaultCostConsumptionModeSHC === USAGE_TYPE.COST ? displayCost({showCurrency: true, cost: point.y}) : displayUsage({showUsageUnit: true, usage: point.y, fuelType: this.props.configs.data.fuelType.toLowerCase()})} </span>${tooltipText}</span>
                        </span>`;
        }, `<span class="tooltip-title"> ${title.startDate} - ${title.endDate} </span>`);
    } //setTooltip

    changeDataToShowOffset(value) {
        const {insightsSHData, changeYearOffset} = this.props;
        let timestamps = insightsSHData.bcTimeStampsData;
        if (insightsSHData.bcTimeStampsData.length >= MAX_BC_TO_SHOW) {
            timestamps = insightsSHData.bcTimeStampsData.slice(insightsSHData.bcTimeStampsData.length - MAX_BC_TO_SHOW - insightsSHData.bcIndexOffset, insightsSHData.bcTimeStampsData.length - insightsSHData.bcIndexOffset);
        }

        // call analytics function to save arrow click event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            dashboardView: FUEL_TYPE.ELECTRIC,
            shown: INSIGHTS_PAGES.SIMILAR_HOMES,
            usageArrowCicked: value === 1 ? ARROWS.LEFT : ARROWS.RIGHT,
            intervalStart: timestamps[0].start,
            intervalEnd: timestamps[timestamps.length - 1].end,
        });

        changeYearOffset({
            usageChartEvent: USAGE_SHC_EVENTS.CHANGE_YEAR_OFFSET,
            bcIndexOffset: (value === 1 ? insightsSHData.bcIndexOffset + 1 : insightsSHData.bcIndexOffset - 1),
            dataNotAvailableText: '',
            dataEmptyText: ''
        });
    } //changeDataToShowOffset

    //If the highcharts data array contains all values as 0 then show data is not available
    checkIfDataEmpty() {
        const {insightsSHData, translationsData} = this.props;
        let seriesData = insightsSHData.insightsSHChartsData.map(item => item.data);
        //Check if you, average and efficient series are all empty
        if(!checkIfDataEmpty(seriesData)) {
            let dataEmptyText = getDataNotAvailableText(insightsSHData, translationsData.data);
            this.props.dataNotAvailable({
                dataEmptyText: dataEmptyText,
                dataNotAvailableText: '',
                isSHChartLoading: false,
                insightsDataLeftArrowDisabled: (insightsSHData.bcIndexOffset >= insightsSHData.bcDurations.length - MAX_BC_TO_SHOW),
                insightsDataRightArrowDisabled: (insightsSHData.bcIndexOffset === 0),
                usageChartEvent: USAGE_SHC_EVENTS.SET_DATA_NOT_AVAILABLE
            });
        }
    }

    fetchSHCGraphData() {
        const { insightsSHData, userIdentityDetails, translationsData, configs, applianceList } = this.props;
        let dateParams = fetchBillingCycleDateBoundaries(insightsSHData);

        //call api for data
        this.props.fetchSHCGraphData({
            "measurement-type": getBECompatibleFuelType(configs.data['fuelType']),
            "mode": insightsSHData.mode.toLowerCase(),
            "start": dateParams.start,
            "end": dateParams.end,
            "date-format": dateParams.dateFormat,
            "show-appliance-shc": configs.data.enableApplianceSHC === 'true'
        }, userIdentityDetails.userId, insightsSHData, translationsData.data, applianceList);
    } // fetchSHCGraphData end

    onSHCRecoChange(selectedAppliance) {
        this.props.changeSelectedSHCAppliance({
            selectedAppliance,
            usageChartEvent: USAGE_SHC_EVENTS.CHANGE_SELECTED_APPLIANCE,
            dataNotAvailableText: '',
            dataEmptyText: ''
        });
        setTimeout(() => this.setHighchartsData(this.props.insightsSHData.shcChartsPayload));
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            tab : INSIGHTS_PAGES.SIMILAR_HOMES,
            selectedAppliance : getApplianceName(selectedAppliance, this.props.applianceList)
        })
    }

    setHighchartsData(payload) {
        const { insightsSHData, translationsData, configs } = this.props;

        //Save the payload for future use, otherwise on switching to some page and coming back, the payload is no more available and switching to other appliances are not possible
        this.props.saveSHCChartPayload({
            shcChartsPayload: payload,
            usageChartEvent: USAGE_SHC_EVENTS.SAVE_SHC_CHART_DATA_PAYLOAD
        });
        //Filter out billing cycles which do not have itemization
        let graphApiData = payload;
        //If no data is available
        if (graphApiData.length === 0) {
            let dataNotAvailableText = getDataNotAvailableText(insightsSHData, translationsData.data);

            this.props.dataNotAvailable({
                dataNotAvailableText,
                dataEmptyText: '',
                isSHChartLoading: false,
                insightsDataLeftArrowDisabled: (insightsSHData.bcIndexOffset >= insightsSHData.bcDurations.length - MAX_BC_TO_SHOW),
                insightsDataRightArrowDisabled: (insightsSHData.bcIndexOffset === 0),
                usageChartEvent: USAGE_SHC_EVENTS.SET_DATA_NOT_AVAILABLE
            });
            return;
        }

        let dataXAxis = [], bcDurations = [];
        let showDisclaimerMissingInterval = false;
        let showDisclaimerApplianceMissing = false;
        let selectedAppliance = insightsSHData.selectedAppliance;

        graphApiData.map( (item, index) => {
            // Push date labels in x axis to feed highcharts
            let startDate = item.intervalEndDate.split(',')[0];
            let translations = this.props.translationsData.data; 
            if (item.isMissingDataInterval) {
                dataXAxis.push(startDate + translations["DISCLAIMER_ICONS.SHC.ICON1"]);
                showDisclaimerMissingInterval = true;
            } else if (item.applianceInfo[selectedAppliance] && "applianceSHCMissing" in item.applianceInfo[selectedAppliance] && item.applianceInfo[selectedAppliance].applianceSHCMissing) {
                dataXAxis.push(startDate + translations["DISCLAIMER_ICONS.SHC.ICON2"]);
                showDisclaimerApplianceMissing = true;
            } else {
                dataXAxis.push(startDate);
            }
            bcDurations.push({
                startDate: item.intervalStartDate,
                endDate: item.intervalEndDate,
                isMissingDataInterval: item.isMissingDataInterval,
            });
        });

        let data = setSHChartDataForBC(graphApiData, configs.data.defaultCostConsumptionModeSHC, selectedAppliance);
        this.props.saveBCData({
            youSeriesData: data.youSeriesData,
            averageSeriesData: data.averageSeriesData,
            efficientSeriesData: data.efficientSeriesData,
            bcTimeStampsData: data.bcTimeStampsData,
            insightsDataLeftArrowDisabled: (insightsSHData.bcIndexOffset >= insightsSHData.bcDurations.length - MAX_BC_TO_SHOW),
            insightsDataRightArrowDisabled: (insightsSHData.bcIndexOffset === 0),
            bcDurations: bcDurations,
            dataXAxis: dataXAxis,
            dataMonthStart: 0,
            dataMonthEnd: 0,
            datasMonthIndex: data.bcTimeStampsData.length - 1,
            showDisclaimerMissingInterval,
            showDisclaimerApplianceMissing,
            usageChartEvent: USAGE_SHC_EVENTS.SAVE_BC_DATA
        });

        //After initializing data to state variables, re-render graph
        //Actions are asynchronous calls, so use setTimeout to call the function after the actions are dispatched and value is set
        setTimeout(() => this.setGraphOptions());
        
    } //setHighchartsData end

    setGraphOptions() {
        let insightsSHChartsData = [];
        let graphType = 'line';
        let seriesNames = ['you', 'efficient', 'average'];
        for (let i = 0; i < seriesNames.length; i++) {
            let name = seriesNames[i];
            let dataKey = `${name}SeriesData`;
            let data = this.props.insightsSHData[dataKey];
            let bcIndexOffset = this.props.insightsSHData.bcIndexOffset;
            if (data.length >= MAX_BC_TO_SHOW) {
                data = data.slice(data.length - (bcIndexOffset + MAX_BC_TO_SHOW), data.length - bcIndexOffset);
            }
            insightsSHChartsData.push({
                name: seriesNames[i],
                type: graphType,
                data: data,
                color: `rgb(${this.configColors[COLOR_PALETTE.shcSeries[name]]})`
            });
        }

        this.props.setSimilarHomesChartsData({
            usageChartEvent: USAGE_SHC_EVENTS.SET_HIGHCHARTS_DATA,
            insightsSHChartsData: insightsSHChartsData
        });
    } //setGraphOptions end

    setBillingCyclesInfo() {
        //Set billing cycle duration text for highcharts
        const { insightsSHData, saveBillingCyclePeriod } = this.props;
        let billingcyclePeriodInfo = '';
        let xAxisData = insightsSHData.bcDurations;
        if (insightsSHData.bcDurations.length >= MAX_BC_TO_SHOW) {
            xAxisData = insightsSHData.bcDurations.slice(insightsSHData.bcDurations.length - MAX_BC_TO_SHOW - insightsSHData.bcIndexOffset, insightsSHData.bcDurations.length - insightsSHData.bcIndexOffset);
        }
        billingcyclePeriodInfo = xAxisData[0].endDate + " - " + xAxisData[xAxisData.length - 1].endDate;
        saveBillingCyclePeriod({
            usageChartEvent: USAGE_SHC_EVENTS.SAVE_BILLING_CYCLE_INFO,
            currentBillingCycleInfo: billingcyclePeriodInfo,
        });
    } // setBillingCycleInfo

    fetchSHCInfoData() {
        const { insightsSHData, userIdentityDetails, apiError, translationsData } = this.props;
        //call api for data
        fetchSHComparisonInfoData({
            "measurement-type": getBECompatibleFuelType(this.props.configs.data['fuelType']),
            "locale": "en_US"
        }, userIdentityDetails.userId).then( (res) => {
            if (res && res.data) {
                this.setSHComparisonData(res);
            } else {
                let dataNotAvailableText = getDataNotAvailableText(insightsSHData, translationsData.data);
                apiError(dataNotAvailableText);
            }
        });
    } //fetchSHCInfoData

    setSHComparisonData(data) {
        let shcData = [];
        data = data.data.payload;
        for(let i = 0; i < data.length; i++) {
            if (data[i].text && data[i].value) {
                shcData.push({
                    'title': data[i].text,
                    'value': data[i].value,
                    'questionId': data[i].questionId
                });
            }
        }

        this.props.setSHCdata({
            shcData,
            usageChartEvent: USAGE_SHC_EVENTS.SET_SHC_DATA
        });

    } //setSHComparisonData

    render() {
        const { insightsSHData, userIdentityDetails, configs, setQueryParams } = this.props;
        return (
            <InsightsSimilarHomes
                applianceList={insightsSHData.appliancesSHCList}
                selectedAppliance={insightsSHData.selectedAppliance}
                insightsSHData={insightsSHData}
                userIdentityDetails={userIdentityDetails}
                changeDataToShowOffset={(value) => this.changeDataToShowOffset(value)}
                translations={this.props.translationsData.data}
                onSHCRecoChange={(id) => this.onSHCRecoChange(id)}
                enableApplianceSHC={configs.data.enableApplianceSHC === 'true'}
                configColors={this.configColors}
                setQueryParams={(queryParamsObj) => setQueryParams(queryParamsObj)}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        insightsSHData : state.similarHomesData,
        userIdentityDetails : state.userIdentityDetails,
        translationsData: state.translationsData,
        queryParams: state.queryParams,
        applianceList: state.appliances.appliancesList,
        configs: state.configs
    }
};

const mapDispatchToProps = dispatch => {
    return {
        apiError: (payload) => dispatch(apiError(payload)),
        saveBillingCyclePeriod: (payload) => dispatch(saveBillingCyclePeriod(payload)),
        setSimilarHomesChartsData: (payload) => dispatch(setSimilarHomesChartsData(payload)),
        saveBCData: (payload) => dispatch(saveBCData(payload)),
        dataNotAvailable: (payload) => dispatch(dataNotAvailable(payload)),
        updateHighChartsObject: (payload) => dispatch(updateHighChartsObject(payload)),
        changeYearOffset: (payload) => dispatch(changeYearOffset(payload)),
        setArrowDisabled: (payload) => dispatch(setArrowDisabled(payload)),
        setSHCdata: (payload) => dispatch(setSHCdata(payload)),
        changeSelectedSHCAppliance: (payload) => dispatch(changeSelectedSHCAppliance(payload)),
        setQueryParams: (queryParamsObj) => dispatch(setQueryParams(queryParamsObj)),
        saveApplianceNavbarList: (payload) => dispatch(saveApplianceNavbarList(payload)),
        saveSHCChartPayload: (payload) => dispatch(saveSHCChartPayload(payload)),
        fetchSHCGraphData: (options, userId, shcData, translations, applianceList) => dispatch(fetchSHCGraphData(options, userId, shcData, translations, applianceList))
    }
};

export default withLastLocation(connect(mapStateToProps, mapDispatchToProps)(InsightsSimilarHomesContainer));
